import {
  CalculateTour,
  CalculateTourStats,
} from '@/domain/impact-calculate-tour/entities/calculate-tour.entity';

import { convertCo2Score } from '../../utils/convert-co2-score';
import { mapCo2 } from './co2/mapper';
import { ResultsTourDto } from './dto.type';
import { mapEnv } from './env/mapper';
import { mapEss } from './ess/mapper';

export class ResultsTourMapper {
  static dtoToEntity(dto: ResultsTourDto): CalculateTour {
    return {
      co2: mapCo2(dto),
      env: mapEnv(dto),
      ess: mapEss(dto),
      stats: mapStats(dto),
    };
  }
}

function mapStats(dto: ResultsTourDto): CalculateTourStats {
  const bySequence = dto.ontour.sequences.reduce<
    CalculateTourStats['ontour']['bySequence']
  >((acc, cur) => {
    acc[cur.id] = {
      eventCount: cur.stats.eventCount,
      co2AveragePerEvent: convertCo2Score(cur.stats.co2AveragePerEvent),
    };
    return acc;
  }, {});

  const byTourTravel = dto.ontour.travels.reduce<
    CalculateTourStats['ontour']['byTourTravel']
  >((acc, cur) => {
    acc[cur.id] = {
      passengerCount: cur.stats.passengerCount,
      weight: cur.stats.weight,
    };
    return acc;
  }, {});
  return {
    ontour: {
      bySequence,
      byTourTravel,
    },
  };
}
